import { ETextStyleVariant, RawButton, RawLink, Text } from '@outdoorsyco/bonfire';
import React from 'react';

import Link from '@/components/switchback/Link/Link';

import { useGlobalHeaderMenuContext } from './GlobalHeaderMenuContext';

type TGlobalHeaderMenuItemProps = {
  icon?: React.ReactNode;
  label: React.ReactNode;
  badge?: React.ReactNode;
  href?: string;
  onClick?: () => void;
  emphasized?: boolean;
};

export const GlobalHeaderMenuItem = ({
  label,
  href,
  onClick,
  icon,
  badge,
  emphasized = false,
}: TGlobalHeaderMenuItemProps) => {
  const { closeMenu } = useGlobalHeaderMenuContext();

  // Always close the menu first, then run the item's own handler. Some items (e.g. a
  // same-page hash link) wouldn't unmount the menu on their own otherwise.
  const handleActivate = () => {
    closeMenu();
    onClick?.();
  };

  const content = (
    <div className="flex items-center justify-between w-full px-5 py-3 gap-4">
      <Text
        component="div"
        variant={emphasized ? ETextStyleVariant.MediumBold : ETextStyleVariant.MediumRegular}
        className="flex items-center gap-3">
        {icon && (
          <span className="text-secondary-base" aria-hidden>
            {icon}
          </span>
        )}
        {label}
      </Text>
      {badge}
    </div>
  );

  if (href) {
    return (
      <Link href={href} legacy>
        <RawLink href={href} className="relative block w-full z-[1]" onClick={handleActivate}>
          {content}
        </RawLink>
      </Link>
    );
  }

  return (
    <RawButton className="relative block w-full z-[1]" onPress={handleActivate}>
      {content}
    </RawButton>
  );
};
